import { elearningConstants } from '../constants';
import { elearningService } from '../services';

import { history } from '../helpers';

const fetchData = (courseCode) => {
  const request = () => ({ type: elearningConstants.FETCH_DATA_REQUEST });
  const success = (data) => ({ type: elearningConstants.FETCH_DATA_SUCCESS, data });
  const failure = (error) => ({ type: elearningConstants.FETCH_DATA_FAILURE, error });

  return dispatch => {
    dispatch(request());
    elearningService.fetchData(courseCode)
      .then(res => {
        const { data, requiresAuth } = res.data;
        if (requiresAuth) {
          history.replace("/login")
          return;
        }
        dispatch(success(data));
      })
      .catch(err => {
        const { status, statusText } = err.response;
        dispatch(failure({ status, statusText }));
      });
  }
}

const updateCoursePrepData = (data) => {
  const request = () => ({ type: elearningConstants.UPDATE_COURSE_PREP_DATA_REQUEST });
  const success = (data) => ({ type: elearningConstants.UPDATE_COURSE_PREP_DATA_SUCCESS, data });
  const failure = (error) => ({ type: elearningConstants.UPDATE_COURSE_PREP_DATA_FAILURE, error });

  return dispatch => {
    dispatch(request());
    elearningService.updateCoursePrepData(data)
      .then(res => {
        const { data, requiresAuth } = res.data;
        if (requiresAuth) {
          history.replace("/login")
          return;
        }
        dispatch(success(data));
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

const completeCourse = (courseCode) => {
  const request = () => ({ type: elearningConstants.COMPLETE_COURSE_REQUEST });
  const success = (data) => ({ type: elearningConstants.COMPLETE_COURSE_SUCCESS, data });
  const failure = (error) => ({ type: elearningConstants.COMPLETE_COURSE_FAILURE, error });

  return dispatch => {
    dispatch(request());
    elearningService.completeCourse(courseCode)
      .then(res => {
        const { successful, data, requiresAuth } = res.data;
        if (requiresAuth) {
          history.replace("/login")
          return;
        }

        dispatch(success(data));
        if (successful) {
          history.replace("/")
        }
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

export const elearningActions = {
  fetchData,
  updateCoursePrepData,
  completeCourse
}
